import { useQuery } from "@tanstack/react-query";

export function Servins(servid) {
   var urlSI = process.env.REACT_APP_URL_DIR + "Servins/" + servid;
   const token = localStorage.getItem("token");
   
   const { data } = useQuery({
      queryKey: ["Servins", servid], // ✅ Agregado servid a la key para cache correcto
      queryFn: async () => {  // ✅ Agregado async aquí
         const response = await fetch(urlSI, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });
         
         if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
         }
         
         return response.json();
      },
      // enabled: !!servid, // ✅ Solo ejecutar si servid existe
      // staleTime: 5 * 60 * 1000, // ✅ Cache por 5 minutos
   });

   return data;
}

export default Servins;